const teamPlayers = [
 /* {
    slug: "pusztitopako",
    name: "Pusztitopako",
    image: "/assets/images/team/Pusztitopako.png",
    status: "Main Roster",
    role: "Professional Player",
    teamRole: "Team Leader / Main Driver",
    nationality: "Hungary",
    wins: 15,
    losses: 4,
    draws: 5,
    description:
      "Pusztitopako is the backbone of the Trackmania roster, bringing leadership, consistency, and elite-level performance in high-pressure competitive environments.",
    highlights: [
      "International tournament experience",
      "Primary in-game leader",
      "Consistent top-tier performances",
    ],
    liquipedia: "https://liquipedia.net/trackmania/Pusztitopako",
  },
  */

  {
    slug: "mime",
    name: "Mime",
    image: "/assets/images/team/Mime.png",
    status: "Main Roster",
    role: "Professional Player",
    teamRole: "Secondary Driver",
    nationality: "France",
    wins: 12,
    losses: 6,
    draws: 3,
    description:
      "Mime is a mechanically gifted player known for aggressive lines, adaptability, and clutch performances across competitive formats.",
    highlights: [
      "Strong mechanical execution",
      "Adaptable playstyle",
      "Reliable under pressure",
    ],
    liquipedia: "https://liquipedia.net/trackmania/Mime",
  },

  {
    slug: "neon",
    name: "Neon",
    image: "/assets/images/team/F9-Logo.svg",
    status: "Academy",
    role: "Academy Player",
    teamRole: "Development Prospect",
    nationality: "France",
    wins: 8,
    losses: 5,
    draws: 2,
    description:
      "Neon represents the next generation of competitive talent, currently focusing on skill development and competitive exposure.",
    highlights: [
      "High growth potential",
      "Rapid improvement curve",
      "Future main-roster candidate",
    ],
    liquipedia: "https://liquipedia.net/trackmania/Neon",
  },

  {
    slug: "droga",
    name: "Droga",
    image: "/assets/images/team/F9-Logo.svg",
    status: "Staff",
    role: "Head Coach",
    teamRole: "Strategy & Performance",
    nationality: "France",
    wins: null,
    losses: null,
    draws: null,
    description:
      "Droga oversees strategic preparation, performance optimization, and overall team discipline. His experience ensures the roster remains competitive at the highest level.",
    highlights: [
      "Match strategy & preparation",
      "Player performance analysis",
      "Team coordination & discipline",
    ],
    liquipedia: "https://liquipedia.net/trackmania/Droga",
  },

  {
    slug: "birdie",
    name: "Birdie",
    image: "/assets/images/team/F9-Logo.svg",
    status: "Creator",
    role: "Content Creator / Streamer",
    teamRole: "Brand & Community",
    nationality: "United Kingdom",
    wins: null,
    losses: null,
    draws: null,
    description:
      "Birdie represents the organization through content creation, live streaming, and community engagement, helping expand the team’s brand beyond competition.",
    highlights: [
      "Live streaming & content creation",
      "Community engagement",
      "Brand growth & visibility",
    ],
    liquipedia: "https://liquipedia.net/trackmania/Birdie",
  },
];

export default teamPlayers;
